import s from './ModalBottomActions.module.scss';
import { Flex } from '@tremor/react';
import { FC, HTMLAttributes } from 'react';
import { OutlinedButton } from '../../Buttons/OutlinedButton/OutlinedButton';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean;
  setClose: () => void;
  form?: string;
  acceptLabel?: string;
  cancelDisabled?: boolean;
  disabled?: boolean;
}

export const ModalBottomActions: FC<Props> = ({
  setClose,
  isLoading = false,
  form,
  acceptLabel = 'Confirm',
  className,
  cancelDisabled = false,
  disabled = false,
  ...rest
}) => {
  return (
    <Flex className={[s.actionButtonsContainer, className].join(' ')} {...rest}>
      <OutlinedButton
        onClick={setClose}
        className={s.actionButton}
        disabled={isLoading || cancelDisabled}
      >
        Cancel
      </OutlinedButton>
      <OutlinedButton
        disabled={disabled}
        isLoading={isLoading}
        type="submit"
        className={[s.actionButton, s.filledButton].join(' ')}
        form={form}
      >
        {acceptLabel}
      </OutlinedButton>
    </Flex>
  );
};
